import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface DrawerState {
  open: boolean
}

const initialState: DrawerState = {
  open: false,
}

export const drawerSlice = createSlice({
  initialState,
  name: 'drawer',
  reducers: {
    setDrawerOpen(state, action: PayloadAction<boolean>) {
      state.open = action.payload
    },
  },
})

export const { setDrawerOpen } = drawerSlice.actions
